import React, { useState, useEffect } from "react";
import HojaEtiquetas from "../../sharecomponents/hojaEtiquetas";
import axios from "axios";
import { setUserSession, getWeekNumber, PHP_BACK } from "../../../utils/Common";
import { Etiqueta } from "./etiqueta";

const Etiquetas_vivero = () => {
    const [loader, setloader] = useState(false);
    const [etiquetas, setetiquetas] = useState([]);
    const [etiqConcentrado, setetiqConcentrado] = useState([])
    const [dia, setdia] = useState(0);
    const [semana, setsemana] = useState("");
    const [semanas, setsemanas] = useState([]);


    var keyy = 1513515;
    useEffect(() => {
        axios.get(PHP_BACK + 'etiquetas/vivero/semanas_activas')
            .then(r => {
                setsemanas(r.data.semanas);
            })
            .catch(e => { setloader(false) });

        // getEtiquetas(undefined,true);

    }, []);

    const keyGen = () => {
        keyy++;
        return keyy;
    }

    const diaNombre = () => {
        let dias = ['', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
        return dias[dia];
    }
    const getEtiquetas = (data) => {
        if (!data || data.semana == 'Seleccione una' || data.dia < 1) return;
        setloader(true);
        axios.post(PHP_BACK + 'etiquetas/vivero', {}, { params: data })
            .then(r => {
                setetiqConcentrado(aplicar_constraccioness(r.data.data));
                setloader(false);
            })
            .catch(e => { setloader(false) });
    }

    function aplicar_constraccioness(data) {
        let flowers = {
            "AGERATHUM": "AGE",
            "AMARANTHUS": "AMARANTHUS",
            "ASTER": "AST",
            "BRASSICA": "BRASSICA",
            "BUNNY": "BUN",
            "CARTHAMUS": "CARTHAMUS",
            "CHANTILLY": "CHANTILLY",
            "CRASPEDIA": "CRASPEDIA",
            "DIANTHUS": "DIANTHUS",
            "HELICHRYSUM": "HM",
            "MARIGOLD": "MARIGOLD",
            "MATRICARIA": "MAT",
            "MOLUCELLA": "MOLUCELLA",
            "QUEEN": "QUEEN",
            "SNAPDRAGON": "SNP",
            "STOCK": "STOCK",
            "SUNFLOWER": "SUNFLOWER",
            "MARIGOLD": "MG",
            "DIANTHUS": "DI",
            "CARTHAMO": "CAR",
            "BRASSICA": "FK"
        };

        for (let i = 0; i < data.length; i++) {
            data[i].flor = flowers[data[i].flor.toUpperCase()] ? flowers[data[i].flor.toUpperCase()] : data[i].flor.toUpperCase();
        }
        return data;
    }

    const despliegueEtiquetas = () => {
        setetiquetas([]);
        let etiq = [];
        etiqConcentrado.forEach(e => {
            for (let i = 0; i < e.cantidad; i++) {
                etiq.push({
                    flor: `${e.flor} ${e.variedad} ${e.color}`,
                    semana: e.semanainicio,
                    dia: dia,
                    transplante: e.transplante,
                    cosecha: e.semanaCosecha
                });

            }
        });
        setetiquetas([...etiq]);
    }

    const addEtik = (index, add) => {
        let e = etiqConcentrado;
        if (add) e[index].cantidad++;
        else if (e[index].cantidad > 0) e[index].cantidad--;
        setetiqConcentrado([...e]);

    }

    const totalEtiquetas = () => {
        let total = 0;
        etiqConcentrado.forEach(element => {
            total += element.cantidad;
        });
        if (total == 0) return '';
        return `Etiquetas totales ${total}`;
    }

    return (

        <div className='vw-100 h-100 p-1 m-0' style={{ overflow: 'auto' }}>
            {/*<HojaEtiquetas/>*/}
            <div className='row justify-content-center vw-100 m-0 p-0'>
                <div className='col-lg-12 p-3'> <span className="h3">Etiquetas {diaNombre() != "" ? " (" + diaNombre() + ")" : ""}</span> <span className="text-m ms-3">Genere etiquetas automaticamente para vivero</span></div>
                <div className='col-lg-12 p-3'>
                    <div className='row justify-content-start m-0 p-0 w-100'>
                        <div className='form-group col-md-3'>
                            <label className="text-bold text-floricents">Seleccione una semana</label>
                            <select className='form-control' placeholder='' value={semana} onChange={(e) => { setsemana(e.target.value); setetiquetas([]); getEtiquetas({ semana: e.target.value, dia: dia }, false) }}>
                                {
                                    semanas.map((s) => {
                                        return (<option value={s} key={keyGen()}>{s}</option>)
                                    })
                                }
                            </select>
                        </div>
                        <div className='form-group col-md-4'>
                            <label className="text-bold text-floricents">Seleccione un día de la semana</label>
                            <select className='form-control' placeholder='' value={dia} onChange={(e) => { setdia(e.target.value); setetiquetas([]); getEtiquetas({ semana: semana, dia: e.target.value }, false) }}>
                                <option value='0' >Seleccione uno</option>
                                <option value='1' >Lunes</option>
                                <option value='2' >Martes</option>
                                <option value='3' >Miercoles</option>
                                <option value='4' >Jueves</option>
                                <option value='5' >Viernes</option>
                                <option value='6' >Sábado</option>
                            </select>
                        </div>

                        <div className='col-lg-2 text-center contenedor pt-3'>
                            {etiqConcentrado.length > 0 && <button className='btn btn-warning shadow border border-dark text-bold' onClick={despliegueEtiquetas}>Generar etiquetas</button>}
                        </div>
                    </div>


                </div>

            </div>
            <div className='row justify-content-start vw-100 p-0 m-0' style={{ overflow: 'auto' }}>
                {
                    etiqConcentrado.map((etiq, j) => {
                        return (
                            <div className='row justify-content-start m-0 ps-2 mt-2 pb-1 ' key={keyGen()}>
                                <div className='col-sm-2 ' >
                                    <Etiqueta keys={keyGen()} data={{
                                        flor: `${etiq.flor} ${etiq.variedad} ${etiq.color}`,
                                        dia: dia,
                                        semana: etiq.semanainicio,
                                        transplante: etiq.transplante,
                                        cosecha: etiq.semanaCosecha
                                    }} />
                                </div>
                                <div className='col-sm-3 contenedor'>
                                    <span className="text-m">{etiq.cantidad}</span> <span className="text-s ps-3 text-bold" >copias</span>
                                </div>
                                <div className='col-sm-3'>
                                    <div className="btn-group" role="group" aria-label="Basic example">
                                        <button type="button" className="btn btn-sm btn-light floricents-bg border-info shadow-sm text-danger m-1 text-bold" onClick={() => { addEtik(j, false) }}>-1</button>

                                        <button type="button" className="btn btn-sm btn-light border border-info shadow-sm text-dark m-1 text-bold" onClick={() => { addEtik(j, true) }}>+1</button>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
                <div className='vw-100 text-l text-bold text-start ps-2 border-top p-0 m-0' style={{ overflow: 'auto' }}>
                    {totalEtiquetas()}
                </div>
            </div>
            <div className='vw-100 m-0 p-0' style={{ overflow: 'auto' }}>
                {etiquetas.length > 0 && <HojaEtiquetas etiquetas={etiquetas} loader={(l) => setloader(l)} />}
            </div>

            {loader && <div className="frontal-blur-transparent-sm"> <div className="loader"></div></div>}
        </div>


    )
}
export default Etiquetas_vivero;
